var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.091 6.314H5.759c-1.012 0-1.832.884-1.832 1.976v8.822c0 1.087.82 1.976 1.832 1.976h.575l1.4 3.018c.243.528.621.828 1.04.828.417 0 .796-.3 1.042-.827l1.4-3.019h7.879c1.01 0 1.832-.884 1.832-1.978V8.29c-.002-1.092-.823-1.976-1.836-1.976zm.837 10.796c0 .5-.376.903-.837.903h-8.183a.494.494 0 0 0-.445.298l-1.537 3.316a.713.713 0 0 1-.15.225.63.63 0 0 1-.149-.225L7.09 18.311a.49.49 0 0 0-.444-.298H5.76c-.462 0-.837-.404-.837-.903V8.29c0-.498.375-.902.837-.902h13.333c.462 0 .838.405.838.902v8.822h-.004l.001-.002z",
    fill: "#9D9D9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.928 13.112c.553 0 1-.501 1-1.12 0-.618-.447-1.12-1-1.12-.552 0-1 .502-1 1.12 0 .619.448 1.12 1 1.12zM11.928 13.112c.553 0 1-.501 1-1.12 0-.618-.447-1.12-1-1.12-.552 0-1 .502-1 1.12 0 .619.448 1.12 1 1.12zM14.928 13.112c.553 0 1-.501 1-1.12 0-.618-.447-1.12-1-1.12-.552 0-1 .502-1 1.12 0 .619.448 1.12 1 1.12z",
    fill: "#9D9D9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.80f06ad935158d7a71fc42e2be8002bd.svg";
export { ForwardRef as ReactComponent };